import '../../shared/deadline/deadline.js';
import '../../shared/booking_modal/booking_modal';
import '../../shared/pre_reservations_index_list/pre_reservations_index_list';
import '../../pages/edit_user_page/edit_user_page';
import '../../shared/my_iberostar_menu/my_iberostar_menu';
import '../../shared/next_bookings/next_bookings';
import '../../shared/quote_form/quote_form';
import '../../shared/dashboard_booking_row/dashboard_booking_row';

$(function () {
  if ($('.my-iberostar-page').length) { // checks if in MIB to prevent crash with drop-down-links in destination page
    $(document).on('click', '.drop-down-links:not(.js-language-selector-links) a', function (e) {
      e.preventDefault();

      let $this = $(this);
      let $cnt = $this.closest('.booking-categories-cnt');
      let $cnt_drop_down = $this.closest('.drop-down-links');
      let category = $this.data('category');
      let text = $this.text();
      let $bookings = $('.dashboard-booking-row').find('.block-cnt > .block-cnt-parent');

      $cnt_drop_down.hide();
      $cnt.find('.d-link').removeClass('active');
      $cnt.find('> a').text(text);

      if (typeof category == 'undefined') return;

      if (category === 'all') {
        $bookings.find('.js-block-cnt-child').show();
      } else {
        $bookings.find('.js-block-cnt-child').hide();
        $bookings.find('.js-block-cnt-child[data-category="' + category + '"]').show();
      }
    });

    let $results_order_by = $('.my-iberostar-page').find('.results-order-by');

    if ($results_order_by.length === 0 || IB.currentDevice !== 'mobile') return false;

    let $select = $('<select class="select-results-order-by"></select>');

    $results_order_by.find('a').removeClass('reversible');
    $select.append($('<option selected value disabled><%= I18n.t("commons.placeholders.select") %></option>'));
    $results_order_by.find('.drop-down-item').not(':first').each(function (index, el) {
      let $el = $(el);
      let text = $el.find('a').text();
      let data = $el.find('a').data('sort');
      let $option = $('<option value="' + data + '">' + text + '</option>');
      $select.append($option);
    });

    $('.select-results-order-by').formikation();
    $('.select-results-order-by').change(function (event) {
      let val = $(this).val();
      $results_order_by.find('[data-sort="' + val + '"]').trigger('click');
    });
  }
});
